import { CountryCode, ProductCode, ProductCodeKey } from '@dayetopia/library';
import Colors from '@components/shared/Colors';
import { ProductCategory, ProductData } from '@contracts';
import { getFromLocalStorage } from '@utils/localStorage';

// TODO separate styles from the actual data (color field should probably go into a separate file)
export const productsData: ProductData[] = [
  {
    id: ProductCodeKey.TamponBox,
    title: 'synced-texts.product-db-name.tampon_box',
    color: Colors.mint,
    url: '/products/tampons/',
    category: ProductCategory.Periodcare,
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/0d4b50b2-9919-4e1e-bb02-64234268b520_home-product-desktop-tampons.webp?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/7cb7a4c5-c3e8-410f-995c-3108303424a9_home-product-mobile-tampons.webp?auto=compress,format'
  },
  {
    id: 'cbd_tampons',
    title: 'synced-texts.product-db-name.cbd_tampons',
    color: 'linear-gradient(180deg, #F9D07C 0%, #FFFBE7 100%), linear-gradient(180deg, #E5F2E3 0%, #FFFBE7 100%), #E5F2E3',
    url: '/products/cbd-tampons/',
    category: ProductCategory.Periodcare,
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/498047e3-4d20-4d70-8b36-32240276495c_home-product-desktop-cbdtampons.png?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/2fad0238-299a-47a1-9a01-81f514042886_showcase-cbd-tampons%402x.png?auto=compress,format'
  },
  {
    id: ProductCodeKey.Pads,
    title: 'synced-texts.product-db-name.pads_box',
    color: Colors.mint50,
    url: '/products/organic-hemp-pads/',
    category: ProductCategory.Periodcare,
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/a613b553-b390-4af6-8ff2-9f58a4b523e5_home-product-desktop-pads.webp?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/ba0cc453-c49c-4a4e-90b8-717b184f57bb_home-product-mobile-pads.webp?auto=compress,format'
  },
  {
    id: ProductCodeKey.Proviotics,
    title: 'synced-texts.product-db-name.proviotics',
    category: ProductCategory.Supplements,
    color: Colors.babyBlue,
    url: '/products/proviotics/',
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/111b06a3-3d1e-4fab-a2fb-fe95fe5616c1_proviotics_showcase_image.webp?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/5dae2352-641f-4a8c-8c37-1b71c4624156_proviotics_showcase_mobile.webp?auto=compress,format'
  },
  {
    id: ProductCodeKey.HolidaySampler,
    title: 'synced-texts.product-db-name.holiday_sampler',
    subtitle: 'components.product-subtitles.with-scrunchie',
    category: ProductCategory.Periodcare,
    url: '/festive/'
  },
  {
    id: ProductCodeKey.Sampler,
    title: 'synced-texts.product-db-name.sampler',
    color: Colors.paleGold,
    url: '/products/sampler/',
    category: ProductCategory.Periodcare,
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/6352f6a9-feb8-4c5f-843c-a27c495e595f_home-product-desktop-sampler.webp?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/f3d75e86-c6ab-417c-a8d3-4d47268a08d6_home-product-mobile-sampler.webp?auto=compress,format'
  },
  {
    id: ProductCodeKey.ValentinesSampler,
    title: 'synced-texts.product-db-name.valentines_sampler',
    subtitle: 'components.product-subtitles.with-scrunchie',
    category: ProductCategory.Periodcare,
    url: '/valentines/'
  },
  {
    id: ProductCodeKey.RoseCandle,
    title: 'synced-texts.product-db-name.rose_candle',
    category: ProductCategory.Gifts,
    url: '/products/your-vagina-smells-fine-candle/'
  },
  {
    id: ProductCodeKey.ValentinesBox,
    title: 'synced-texts.product-db-name.valentines_box',
    category: ProductCategory.Periodcare,
    url: '/valentines/'
  },
  {
    id: ProductCodeKey.BlmPin,
    title: 'synced-texts.product-db-name.blm_pin',
    category: ProductCategory.Other,
    url: '/products/blm-pin/'
  },
  {
    id: ProductCodeKey.Masks,
    title: 'synced-texts.product-db-name.masks',
    category: ProductCategory.Other,
    url: '/products/masks/',
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/c4994579-bc19-4be4-abfc-54b73e4b47a3_home-product-desktop-masks.webp?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/ed7d15c3-fb2a-43c6-9d8c-1186d4160f80_home-product-mobile-masks.webp?auto=compress,format',
    color: `${Colors.ecru}50`
  },
  {
    id: ProductCodeKey.MaskLight,
    title: 'synced-texts.product-db-name.mask_light',
    subtitle: 'components.product-subtitles.cream-pink',
    category: ProductCategory.Other,
    url: '/products/masks/'
  },
  {
    id: ProductCodeKey.MaskDark,
    title: 'synced-texts.product-db-name.mask_dark',
    subtitle: 'components.product-subtitles.lilac-forest',
    category: ProductCategory.Other,
    url: '/products/masks/'
  },
  {
    id: ProductCodeKey.MaskBlue,
    title: 'synced-texts.product-db-name.mask_blue',
    subtitle: 'components.product-subtitles.navy-sage',
    category: ProductCategory.Other,
    url: '/products/masks/'
  },
  {
    id: ProductCodeKey.MaskPink,
    title: 'synced-texts.product-db-name.mask_pink',
    subtitle: 'components.product-subtitles.gold-pink',
    category: ProductCategory.Other,
    url: '/products/masks/'
  },
  {
    id: ProductCodeKey.VaginaMattersBook,
    title: 'synced-texts.product-db-name.vagina_matters_book',
    category: ProductCategory.Other,
    url: '/products/vagina-matters-book/'
  },
  {
    id: ProductCodeKey.GiftCard,
    title: 'synced-texts.product-db-name.gift_card',
    category: ProductCategory.Other,
    url: '/products/gift-card/'
  },
  {
    id: ProductCodeKey.TamponTin,
    title: 'synced-texts.product-db-name.tin_case',
    category: ProductCategory.Other,
    url: '/products/tampon-case/'
  },
  {
    id: ProductCodeKey.USWaitlistPrepaid12,
    title: 'synced-texts.product-db-name.us_waitlist_prepaid_12',
    category: ProductCategory.Other
  },
  {
    id: ProductCodeKey.USWaitlistPrepaid18,
    title: 'synced-texts.product-db-name.us_waitlist_prepaid_18',
    category: ProductCategory.Other
  },
  {
    id: ProductCodeKey.TamponPouch,
    title: 'synced-texts.product-db-name.tampon_pouch',
    category: ProductCategory.Other
  },
  {
    id: ProductCodeKey.ScreeningKit,
    title: 'synced-texts.product-db-name.screening_kit',
    url: '/products/at-home-vaginal-screening/',
    category: ProductCategory.VaginalCare,
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/2df980ac-38f8-4c59-9013-9f52c66e7095_home-product-desktop-vms.png?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/77942e80-739a-4004-aa70-a08475d2eb93_showcase-diagnostic-tampon%402x.png?auto=compress,format',
    color: `linear-gradient(0deg, #D1E1EE 0%, #FAECE9 82.05%)`
  },
  {
    id: ProductCodeKey.VMSEssential,
    title: 'synced-texts.product-db-name.vms_essential',
    url: '/products/at-home-vaginal-screening/',
    category: ProductCategory.VaginalCare,
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/32504c93-8d47-41c7-bd44-e485d6c3d774_home-product-desktop-vms.webp?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/68c68379-175e-4a2d-a341-777a93da902f_home-product-mobile-vms.webp?auto=compress,format',
    color: `${Colors.babyBlue}`
  },
  {
    id: ProductCodeKey.VMSAdvanced,
    title: 'synced-texts.product-db-name.vms_advanced',
    url: '/products/at-home-sti-screening/',
    category: ProductCategory.VaginalCare,
    color: `${Colors.babyBlue}`
  },
  {
    id: ProductCodeKey.VMSPremium,
    title: 'synced-texts.product-db-name.vms_premium',
    url: '/products/at-home-sti-screening/',
    category: ProductCategory.VaginalCare,
    color: `${Colors.babyBlue}`
  },
  {
    id: ProductCodeKey.Femoflor,
    title: 'synced-texts.product-db-name.femoflor',
    url: '/products/at-home-sti-screening/',
    category: ProductCategory.VaginalCare,
    color: `${Colors.babyBlue}`
  },
  {
    id: ProductCodeKey.FemoflorHpv,
    title: 'synced-texts.product-db-name.femoflor_hpv',
    url: '/products/at-home-sti-screening/',
    category: ProductCategory.VaginalCare,
    color: `${Colors.babyBlue}`
  },
  {
    id: ProductCodeKey.STIScreening,
    title: 'synced-texts.product-db-name.sti_screening',
    url: '/products/at-home-sti-screening/',
    category: ProductCategory.VaginalCare,
    color: `${Colors.powderPink}`,
    showcaseImage: 'https://images.prismic.io/ecommerce-website/4315a57f-c2a6-4449-a6c6-118591a04329_sti_screening%402x.png?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/4315a57f-c2a6-4449-a6c6-118591a04329_sti_screening%402x.png?auto=compress,format'
  },
  {
    id: ProductCodeKey.HPVScreening,
    title: 'synced-texts.product-db-name.hpv_screening',
    url: '/products/at-home-hpv-screening/',
    category: ProductCategory.VaginalCare,
    color: `${Colors.powderPink}`,
    showcaseImage: 'https://images.prismic.io/ecommerce-website/Zw0X9YF3NbkBXZn4_HPV_screen_thumbnail.png?auto=format,compress',
    showcaseImageMobile: 'https://images.prismic.io/ecommerce-website/Zw0X9YF3NbkBXZn4_HPV_screen_thumbnail.png?auto=format,compress'
  },
  {
    id: ProductCodeKey.HPVAdvanced,
    title: 'synced-texts.product-db-name.hpv_advanced',
    url: '/products/at-home-hpv-screening/',
    category: ProductCategory.VaginalCare
  },
  {
    id: ProductCodeKey.VMSMedicationFee,
    title: 'synced-texts.product-db-name.vms_medication_fee',
    color: `${Colors.babyBlue}`
  },
  {
    id: ProductCodeKey.VMSPrescriptionFee,
    title: 'synced-texts.product-db-name.vms_prescription_fee',
    color: `${Colors.babyBlue}`
  },
  {
    id: ProductCodeKey.VMSEssentialReplacement,
    title: 'synced-texts.product-db-name.vms_essential_replacement',
    category: ProductCategory.Other
  },
  {
    id: ProductCodeKey.PPCStandard,
    title: 'synced-texts.product-db-name.ppc_standard',
    url: '/period-pain-clinic',
    subtitle: 'components.product-subtitles.standard',
    category: ProductCategory.Other,
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/0447e1d5-c740-47f4-8914-aa274d3dff08_home-product-desktop-ppc.png?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/e32a6742-fc09-4bf6-8398-99b55a70d66d_showcase-ppc%402x.png?auto=compress,format',
    color: 'linear-gradient(180deg, #F1F6E4 0%, #E5F2E3 100%), #E5F2E3'
  },
  {
    id: ProductCodeKey.PPCAdvanced,
    title: 'synced-texts.product-db-name.ppc_advanced',
    category: ProductCategory.Other,
    // TODO rethink if the includes field should be in the products list. It concerns only the PPC
    includes: ['components.product-includes.personalised-report']
  },
  {
    id: ProductCodeKey.PPCPremium,
    title: 'synced-texts.product-db-name.ppc_premium',
    subtitle: 'components.product-subtitles.premium-package',
    category: ProductCategory.Other,
    includes: ['components.product-includes.full-period-pain-report', 'components.product-includes.pharmacist-review-fee']
  },
  {
    id: ProductCodeKey.PPCTamponBox,
    title: 'synced-texts.product-db-name.ppc_tampon_box',
    color: Colors.mint,
    url: '/products/tampons/',
    category: ProductCategory.Periodcare,
    showcaseImage:
      'https://images.prismic.io/ecommerce-website/0d4b50b2-9919-4e1e-bb02-64234268b520_home-product-desktop-tampons.webp?auto=compress,format',
    showcaseImageMobile:
      'https://images.prismic.io/ecommerce-website/7cb7a4c5-c3e8-410f-995c-3108303424a9_home-product-mobile-tampons.webp?auto=compress,format'
  },
  {
    id: ProductCodeKey.ConsultationSexualHealth,
    title: 'synced-texts.product-db-name.consultation_sexual_health',
    url: '/products/nurse-consultation/',
    category: ProductCategory.Consultation,
    includes: ['components.product-includes.30-minute-consultation-specialist-nurse']
  },
  {
    id: ProductCodeKey.ConsultationFertility,
    title: 'synced-texts.product-db-name.consultation_fertility',
    category: ProductCategory.Consultation,
    includes: ['components.product-includes.30-minute-consultation-fertility-specialist']
  },
  {
    id: ProductCodeKey.ConsultationNutritionist,
    title: 'synced-texts.product-db-name.consultation_nutritionist',
    category: ProductCategory.Consultation,
    includes: ['components.product-includes.45-min-consultation-nutritional-therapist']
  },
  {
    id: ProductCodeKey.ConsultationGeneralPractitioner,
    title: 'synced-texts.product-db-name.consultation_general_practitioner',
    category: ProductCategory.Consultation,
    includes: ['components.product-includes.15-min-consultation-gp']
  },
  {
    id: ProductCodeKey.ConsultationPelvicFloorTherapist,
    title: 'synced-texts.product-db-name.consultation_pelvic_floor_therapist',
    category: ProductCategory.Consultation,
    includes: ['components.product-includes.45-min-consultation-pelvic-floor-specialist']
  },
  {
    id: ProductCodeKey.FestiveBundle,
    url: '/products/gift-bundle/',
    title: 'synced-texts.product-db-name.festive_bundle'
  },
  {
    id: ProductCodeKey.VaginalHealthBundle,
    url: '/products/vaginal-health-bundle',
    title: 'synced-texts.product-db-name.proviotics_vaginal_health'
  },
  {
    id: ProductCodeKey.HormonalTestBase,
    title: 'synced-texts.product-db-name.ht_base_day3',
    url: '/products/hormone-test/',
    category: ProductCategory.HormoneTest
  },
  {
    id: ProductCodeKey.HormonalTestBaseAndAMH,
    title: 'synced-texts.product-db-name.ht_base_day3_expanded',
    url: '/products/hormone-test/',
    category: ProductCategory.HormoneTest
  },
  {
    id: 'donation_gb',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_de',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_nl',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_ie',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_be',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_it',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_es',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_pt',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_bg',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_fr',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_us',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_se',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_dk',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_no',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_fi',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_at',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  },
  {
    id: 'donation_ch',
    title: 'synced-texts.product-db-name.donation',
    category: ProductCategory.Donation
  }
];

export const getProductTitle = (productCode: ProductCodeKey | string): string => {
  return `synced-texts.product-db-name.${productCode}`;
};

export const getDBProductName = (productCode: ProductCodeKey | string): string => {
  const pricesData = getFromLocalStorage('productPrices', true);
  const product = pricesData && Array.isArray(pricesData) ? pricesData?.find((item) => item.id === productCode) : null;

  if (product && product.name) {
    return product.name;
  }

  const productData = productsData.find((p) => p.id === productCode);
  if (productData) return productData.title;

  return ProductCode[productCode as keyof typeof ProductCode];
};

export const getProductSubtitle = (productCode: string) => {
  const productData = productsData.find((product) => product.id === productCode);
  if (productData) return productData.subtitle;
  return '';
};

export const getListOfIncludesForProduct = (productCode: string) => {
  const productData = productsData.find((product) => product.id === productCode);
  if (productData) return productData.includes ?? [];
  return [];
};

export const getProductLink = (productCode: string, country: CountryCode | undefined = undefined) => {
  const productData = productsData.find((product) => product.id === productCode);
  if (productData) return productData.url || '';
  if (productCode.includes('_bundle_')) return getTamponBundleLink(productCode);
  if (productCode.includes('pads_box')) return '/products/organic-hemp-pads/';
  if (country && productCode.includes('tampon_box')) return getTamponsLink(productCode, country);

  return '';
};

export const getProductCategory = (productCode: string) => {
  const productData = productsData.find((product) => product.id === productCode);
  if (productData) return productData.category;
  return '';
};

const getTamponsLink = (productCode: string, country: CountryCode) => {
  if (!productCode.includes('tampon_box')) return '';

  if (country === CountryCode.US) return '/products/organic-nude-tampons/';

  // both numbers present (e.g. _9nr9cr or _18nr18cr)
  if (/_\d+nr\d+cr$/.test(productCode) || /_(\d+)nr\1cr$/.test(productCode)) return '/products/organic-cbd-nude-tampons/';
  // only CBD (e.g. _9cr)
  if (/_\d+cr$/.test(productCode)) return '/products/organic-cbd-tampons/';
  // only Nude (e.g. _9nr)
  if (/_\d+nr$/.test(productCode)) return '/products/organic-nude-tampons/';

  return '';
};

const getTamponBundleLink = (productCode: string) => {
  if (productCode.includes('tampon_box_bundle_regular_flow')) return '/products/organic-reg-flow-bundle/';
  if (productCode.includes('tampon_box_bundle_heavy_flow')) return '/products/organic-heavy-flow-bundle/';
  return '';
};
